import {ApiRes} from '../../types/api'
import {API_URL, apiPost} from '../api'

interface IResLogin {
    access_token?: string
    email_confirmed?: boolean
    success?: boolean
    user_id?: string
    error?: string
}

export const postLoginApi = async (email: string, password: string): Promise<ApiRes<IResLogin>> => {
    return await apiPost(API_URL, 'signin/email', {email: email, password: password})
}
